module.exports = __webpack_public_path__ + "img/ski_sub_title7m.3410bd8a.png";